import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={17.927} height={17.927} {...props}>
      <defs>
        <style>{'.prefix__cls-1{fill:#fff}'}</style>
      </defs>
      <g id="prefix__ios-minus-outline" transform="translate(-3.375 -3.375)">
        <path
          id="prefix__Path_5634"
          data-name="Path 5634"
          className="prefix__cls-1"
          d="M12.338 3.375a8.963 8.963 0 108.962 8.963 8.962 8.962 0 00-8.962-8.963zm0 17.182a8.218 8.218 0 118.218-8.218 8.228 8.228 0 01-8.218 8.218z"
        />
        <path
          id="prefix__Path_5635"
          data-name="Path 5635"
          className="prefix__cls-1"
          d="M9 17.438h11.032v.732H9z"
          transform="translate(-2.178 -5.444)"
        />
      </g>
    </svg>
  );
}

export default SvgComponent;
